var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBonusesUsed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 19.8333L22.8333 36.1667M25.1667 22.1667H25.19M36.8333 33.8333H36.8567M10 28C10 16.402 19.402 7 31 7C42.5981 7 52 16.402 52 28C52 39.5981 42.5981 49 31 49H11M26.3333 22.1667C26.3333 22.811 25.811 23.3333 25.1667 23.3333C24.5223 23.3333 24 22.811 24 22.1667C24 21.5223 24.5223 21 25.1667 21C25.811 21 26.3333 21.5223 26.3333 22.1667ZM38 33.8333C38 34.4776 37.4776 35 36.8333 35C36.1891 35 35.6667 34.4776 35.6667 33.8333C35.6667 33.1891 36.1891 32.6667 36.8333 32.6667C37.4776 32.6667 38 33.1891 38 33.8333Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 35H15.6667M8.66667 42H20.3333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusesUsed);
export default __webpack_public_path__ + "static/media/bonuses-used.0455cb2dc3a747766f8e198a603f9d05.svg";
export { ForwardRef as ReactComponent };